export default {
  install: (Vue) => {
    // The nested nav keeps the top bar and sidebar fixed and scrolls .content
    // instead, so the window no longer scrolls. Scrolling the window here would
    // be a silent no-op — the native call finds whichever ancestor actually
    // scrolls, which works both inside the nested nav and on full-page views.
    //
    // behavior/block options need Chrome 61, below the Tizen 4 floor, but
    // smoothscroll-polyfill (installed in main.ts) patches
    // Element.prototype.scrollIntoView to accept them. FAQs, PrivacyPolicy and
    // EPGListing already call it this way.
    Vue.prototype.$scrollIntoView = (element) => {
      if (!element) return;
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  },
};
